import { createAction, tableActions } from '../helpers/reduxHelpers';

export const inventoryItemActionTypes = {
  INVENTORY_ITEM_SEARCH: 'INVENTORY_ITEM_SEARCH',
  INVENTORY_ITEM_LOADING: 'INVENTORY_ITEM_LOADING',
  GET_PREVIEW_LIST_SUCCESS: 'GET_PREVIEW_LIST_SUCCESS',
  GET_INVENTORY_ITEM_SUCCESS: 'GET_INVENTORY_ITEM_SUCCESS',
  INVENTORY_ITEM_PAGE_CHANGED: 'INVENTORY_ITEM_PAGE_CHANGED',
  INVENTORY_ITEM_SORT_CHANGED: 'INVENTORY_ITEM_SORT_CHANGED',
  INVENTORY_ITEM_CHECK_CHANGED: 'INVENTORY_ITEM_CHECK_CHANGED',
  INVENTORY_ITEM_FILTER_CHANGED: 'INVENTORY_ITEM_FILTER_CHANGED',
  INVENTORY_ITEM_ALL_CHECK_CHANGED: 'INVENTORY_ITEM_ALL_CHECK_CHANGED',
  INVENTORY_ITEM_STOCK_PRODUCT_SUBMIT: 'INVENTORY_ITEM_STOCK_PRODUCT_SUBMIT',
  INVENTORY_ITEM_OPEN_LOCATIONS_TABLE: 'INVENTORY_ITEM_OPEN_LOCATIONS_TABLE',
  INVENTORY_ITEM_CLOSE_LOCATIONS_TABLE: 'INVENTORY_ITEM_CLOSE_LOCATIONS_TABLE',
  INVENTORY_ITEM_LOCATIONS_TABLE_ITEM_SUBMIT:
    'INVENTORY_ITEM_LOCATIONS_TABLE_ITEM_SUBMIT',
  GET_INVENTORY_ITEM_LOCATIONS_TABLE_SUCCESS:
    'GET_INVENTORY_ITEM_LOCATIONS_TABLE_SUCCESS',
  INVENTORY_ITEM_LOCATIONS_TABLE_SORT_CHANGED:
    'INVENTORY_ITEM_LOCATIONS_TABLE_SORT_CHANGED',
};

export const invByLocationActionTypes = {
  INV_BY_LOCATION_LOADING: 'INV_BY_LOCATION_LOADING',
  INV_BY_LOCATIONS_ITEM_SUBMIT: 'INV_BY_LOCATIONS_ITEM_SUBMIT',
  COPY_INV_TO_LOCATION_LOADING: 'COPY_INV_TO_LOCATION_LOADING',
  COPY_INV_TO_LOCATION_COMPLETE: 'COPY_INV_TO_LOCATION_COMPLETE',
  INV_BY_LOCATION_PAGE_CHANGED: 'INV_BY_LOCATION_PAGE_CHANGED',
  INV_BY_LOCATION_SORT_CHANGED: 'INV_BY_LOCATION_SORT_CHANGED',
  INV_BY_LOCATION_SUMMARY_LOADED: 'INV_BY_LOCATION_SUMMARY_LOADED',
  INV_BY_LOCATION_SUMMARY_LOADING: 'INV_BY_LOCATION_SUMMARY_LOADING',
  INV_BY_LOCATION_SELECTED_CHANGED: 'INV_BY_LOCATION_SELECTED_CHANGED',
  REMOVE_INV_FROM_LOCATION_LOADING: 'REMOVE_INV_FROM_LOCATION_LOADING',
  REMOVE_INV_FROM_LOCATION_COMPLETE: 'REMOVE_INV_FROM_LOCATION_COMPLETE',
  INV_BY_LOCATION_ALL_CHECK_CHANGED: 'INV_BY_LOCATION_ALL_CHECK_CHANGED',
  INV_BY_LOCATION_ITEM_CHECK_CHANGED: 'INV_BY_LOCATION_ITEM_CHECK_CHANGED',
  INV_BY_LOCATION_GET_LOCATIONS_SUCCESS:
    'INV_BY_LOCATION_GET_LOCATIONS_SUCCESS',
  INV_BY_LOCATION_INVENTORY_ITEM_LOADING:
    'INV_BY_LOCATION_INVENTORY_ITEM_LOADING',
  GET_INV_ITEM_BY_LOCATION_ITEMS_SUCCESS:
    'GET_INV_ITEM_BY_LOCATION_ITEMS_SUCCESS',
  MOVE_ITEMS: createAction('MOVE_ITEMS'),
};

export const inventoryLocationActionTypes = {
  INVENTORY_LOCATIONS_LOADING: 'INVENTORY_LOCATIONS_LOADING',
  GET_INVENTORY_LOCATIONS_SUCCESS: 'GET_INVENTORY_LOCATIONS_SUCCESS',
  INVENTORY_LOCATION_UPDATED_SUCCESS: 'INVENTORY_LOCATION_UPDATED_SUCCESS',
  INVENTORY_LOCATIONS_LOADING_COMPLETE: 'INVENTORY_LOCATIONS_LOADING_COMPLETE',
  GET_DEFAULT_INVENTORY_LOCATION_SUCCESS:
    'GET_DEFAULT_INVENTORY_LOCATION_SUCCESS',
  INVENTORY_LOCATION_BATCH_SELECT_ALL_UPDATED:
    'INVENTORY_LOCATION_BATCH_SELECT_ALL_UPDATED',
  INVENTORY_LOCATION_BATCH_SELECT_INDIVIDUAL_UPDATED:
    'INVENTORY_LOCATION_BATCH_SELECT_INDIVIDUAL_UPDATED',
};

export const priceListActionTypes = {
  PRICE_LIST_LOADING: 'PRICE_LIST_LOADING',
  GET_PRICE_LIST_SUCCESS: 'GET_PRICE_LIST_SUCCESS',
  PRICE_LIST_SORT_CHANGED: 'PRICE_LIST_SORT_CHANGED',
  PRICE_LIST_PAGE_CHANGED: 'PRICE_LIST_PAGE_CHANGED',
  LOAD_ITEM_TYPES_SUCCESS: 'LOAD_ITEM_TYPES_SUCCESS',
  PRICE_LIST_LOADING_ERROR: 'PRICE_LIST_LOADING_ERROR',
  GET_PREVIEW_LIST_SUCCESS: 'GET_PREVIEW_LIST_SUCCESS',
  PRICE_LIST_DELETE_LOADING: 'PRICE_LIST_DELETE_LOADING',
  PRICE_LIST_DELETE_COMPLETE: 'PRICE_LIST_DELETE_COMPLETE',
  PRICE_LIST_LOADING_COMPLETE: 'PRICE_LIST_LOADING_COMPLETE',
  PRICE_LIST_ITEM_CHECK_CHANGED: 'PRICE_LIST_ITEM_CHECK_CHANGED',
  PRICE_LIST_ALL_CHECKED_CHANGED: 'PRICE_LIST_ALL_CHECKED_CHANGED',
  PRICE_LIST_SEARCH_STRING_CHANGED: 'PRICE_LIST_SEARCH_STRING_CHANGED',
  PRICE_LIST_FILTER_OPTION_CHANGED: 'PRICE_LIST_FILTER_OPTION_CHANGED',
  PRICE_LIST_LOCATIONS_TABLE_SORT_CHANGED:
    'PRICE_LIST_LOCATIONS_TABLE_SORT_CHANGED',
};

export const priceListItemActionTypes = {
  PRICE_LIST_ITEM_RESET: 'PRICE_LIST_ITEM_RESET',
  PRICE_LIST_GET_ITEM_FAIL: 'PRICE_LIST_GET_ITEM_FAIL',
  PRICE_LIST_GET_ITEM_LOADING: 'PRICE_LIST_GET_ITEM_LOADING',
  PRICE_LIST_GET_ITEM_SUCCESS: 'PRICE_LIST_GET_ITEM_SUCCESS',
  PRICE_LIST_ITEM_UPDATE_LOADING: 'PRICE_LIST_ITEM_UPDATE_LOADING',
  PRICE_LIST_ITEM_UPDATE_COMPLETE: 'PRICE_LIST_ITEM_UPDATE_COMPLETE',
  PRICE_LIST_ITEM_INVENTORY_CHANGED: 'PRICE_LIST_ITEM_INVENTORY_CHANGED',
  PRICE_LIST_GET_ITEM_PARENT_SUCCESS: 'PRICE_LIST_GET_ITEM_PARENT_SUCCESS',
  GET_PRICE_LIST_GROUP_ITEMS_SUCCESS: 'GET_PRICE_LIST_GROUP_ITEMS_SUCCESS',
  GET_PRICE_LIST_GROUP_ITEMS_LOADING: 'GET_PRICE_LIST_GROUP_ITEMS_LOADING',
  PRICE_LIST_LOAD_PARENT_ITEMS_SUCCESS: 'PRICE_LIST_LOAD_PARENT_ITEMS_SUCCESS',
  PRICE_LIST_ITEM_GET_INVENTORY_LOADING:
    'PRICE_LIST_ITEM_GET_INVENTORY_LOADING',
  PRICE_LIST_ITEM_GET_INVENTORY_SUCCESS:
    'PRICE_LIST_ITEM_GET_INVENTORY_SUCCESS',
};

export const portalActionTypes = {
  LOAD_ADDON_SUCCESS: 'LOAD_ADDON_SUCCESS',
  LOAD_PORTAL_SUCCESS: 'LOAD_PORTAL_SUCCESS',
  LOAD_PORTAL_SETTINGS: 'LOAD_PORTAL_SETTINGS',
  UPDATE_ADDON_SUCCESS: 'UPDATE_ADDON_SUCCESS',
  UPDATE_PORTAL_SUCCESS: 'UPDATE_PORTAL_SUCCESS',
  LOAD_DICTIONARY_SUCCESS: 'LOAD_DICTIONARY_SUCCESS',
  LOAD_DICTIONARY_COMPLETE: 'LOAD_DICTIONARY_COMPLETE',
  LOAD_PORTAL_SETTINGS_SUCCESS: 'LOAD_PORTAL_SETTINGS_SUCCESS',
  LOAD_PORTAL_SETTINGS_COMPLETE: 'LOAD_PORTAL_SETTINGS_COMPLETE',
  UPDATE_PORTAL_SETTINGS_SUCCESS: 'UPDATE_PORTAL_SETTINGS_SUCCESS',
};

export const timesheetActionTypes = {
  UPDATE_ENTRY: 'UPDATE_ENTRY',
  LOAD_TIMESHEET: 'LOAD_TIMESHEET',
  UPDATE_NEW_ENTRY: 'UPDATE_NEW_ENTRY',
  REMOVE_TIME_ENTRY: 'REMOVE_TIME_ENTRY',
  LOAD_EDIT_TIMESHEET: 'LOAD_EDIT_TIMESHEET',
  CHANGE_SELECTED_DAY: 'CHANGE_SELECTED_DAY',
  SAVE_CHANGES_SUCCESS: 'SAVE_CHANGES_SUCCESS',
  TIMESHEET_DATE_CHANGE: 'TIMESHEET_DATE_CHANGE',
  TIMESHEET_CHANGE_PAGE: 'TIMESHEET_CHANGE_PAGE',
  REMOVE_NEW_TIME_ENTRY: 'REMOVE_NEW_TIME_ENTRY',
  TIMESHEET_SAVE_CHANGES: 'TIMESHEET_SAVE_CHANGES',
  LOAD_TIMESHEET_SUCCESS: 'LOAD_TIMESHEET_SUCCESS',
  LOAD_TIMESHEET_FAILURE: 'LOAD_TIMESHEET_FAILURE',
  NEW_TIME_ENTRY_CREATED: 'NEW_TIME_ENTRY_CREATED',
  SAVE_NEW_ENTRY_SUCCESS: 'SAVE_NEW_ENTRY_SUCCESS',
  DELETE_TIME_ENTRY_SUCCESS: 'DELETE_TIME_ENTRY_SUCCESS',
  LOAD_EDIT_TIMESHEET_SUCCESS: 'LOAD_EDIT_TIMESHEET_SUCCESS',
  LOAD_EDIT_TIMESHEET_FAILURE: 'LOAD_EDIT_TIMESHEET_FAILURE',
  TIMESHEET_SAVE_CHANGES_FAILURE: 'TIMESHEET_SAVE_CHANGES_FAILURE',
};

export const taxActionTypes = {
  LOAD_TAX_CODES_SUCCESS: 'LOAD_TAX_CODES_SUCCESS',
  INITIAL_LOAD: 'TAX_INITIAL_LOAD',
  ...tableActions('TAX'),
};

export const unitsActionTypes = {
  LOAD_UNITS_SUCCESS: 'LOAD_UNITS_SUCCESS',
  NEW_UNIT_ADDED: 'NEW_UNIT_ADDED',
};

export const userActionTypes = {
  TIMEZONE: createAction('TIMEZONE'),
  TOKEN: createAction('TOKEN'),
  UPDATE_USER_PREFERENCE: createAction('UPDATE_USER_PREFERENCE'),
  USER_PREFERENCE: createAction('USER_PREFERENCE'),
};

export const alertActionTypes = {
  ERROR_MSG: 'ERROR_MSG',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SUCCESS_MSG: 'SUCCESS_MSG',
  CLEAR_SUCCESS: 'CLEAR_SUCCESS',
  WARNING_MSG: 'WARNING_MSG',
  CLEAR_WARNING: 'CLEAR_WARNING',
};

export const billingActionTypes = {
  LOAD_COUPON_SUCCESS: 'LOAD_COUPON_SUCCESS',
  BILLING_CUSTOMER_CREATED: 'BILLING_CUSTOMER_CREATED',
  BILLING_GET_PLANS_LOADING: 'BILLING_GET_PLANS_LOADING',
  BILLING_GET_PLANS_SUCCESS: 'BILLING_GET_PLANS_SUCCESS',
  BILLING_CUSTOMER_CREATING: 'BILLING_CUSTOMER_CREATING',
  BILLING_GET_PLANS_COMPLETE: 'BILLING_GET_PLANS_COMPLETE',
  BILLING_SELECTED_PLAN_LOADED: 'BILLING_SELECTED_PLAN_LOADED',
  BILLING_GET_PRODUCTS_COMPLETE: 'BILLING_GET_PRODUCTS_COMPLETE',
  BILLING_SELECTED_PLAN_CHANGED: 'BILLING_SELECTED_PLAN_CHANGED',
  BILLING_SELECTED_PLAN_LOADING: 'BILLING_SELECTED_PLAN_LOADING',
  BILLING_VALIDATE_COUPON_LOADING: 'BILLING_VALIDATE_COUPON_LOADING',
  BILLING_VALIDATE_COUPON_COMPLETE: 'BILLING_VALIDATE_COUPON_COMPLETE',
  BILLING_SELECTED_FREQUENCY_CHANGED: 'BILLING_SELECTED_FREQUENCY_CHANGED',
  BILLING_UPDATE_PLAN_PRODUCT_SELECTIONS:
    'BILLING_UPDATE_PLAN_PRODUCT_SELECTIONS',
};

const SELECT_GOOGLE_CALENDAR = createAction('SELECT_GOOGLE_CALENDAR');

export const myAccountActionTypes = {
  ACCOUNT_LOADING: 'ACCOUNT_LOADING',
  TIMEZONE_LOADING: 'TIMEZONE_LOADING',
  TIMEZONE_LOAD_FAIL: 'TIMEZONE_LOAD_FAIL',
  ACCOUNT_LOAD_ERROR: 'ACCOUNT_LOAD_ERROR',
  GOOGLE_URL_LOADING: 'GOOGLE_URL_LOADING',
  ACCOUNT_LOAD_SUCCESS: 'ACCOUNT_LOAD_SUCCESS',
  UPDATE_ACCOUNT_ERROR: 'UPDATE_ACCOUNT_ERROR',
  SUBSCRIPTION_LOADING: 'SUBSCRIPTION_LOADING',
  TIMEZONE_LOAD_SUCCESS: 'TIMEZONE_LOAD_SUCCESS',
  GOOGLE_URL_LOAD_ERROR: 'GOOGLE_URL_LOAD_ERROR',
  UPDATE_PASSWORD_ERROR: 'UPDATE_PASSWORD_ERROR',
  UPDATE_ACCOUNT_LOADING: 'UPDATE_ACCOUNT_LOADING',
  UPDATE_ACCOUNT_SUCCESS: 'UPDATE_ACCOUNT_SUCCESS',
  UPLOAD_PROFILE_PICTURE: 'UPLOAD_PROFILE_PICTURE',
  REMOVE_PROFILE_PICTURE: 'REMOVE_PROFILE_PICTURE',
  GOOGLE_URL_LOAD_SUCCESS: 'GOOGLE_URL_LOAD_SUCCESS',
  UPDATE_PASSWORD_LOADING: 'UPDATE_PASSWORD_LOADING',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  SUBSCRIPTION_LOAD_ERROR: 'SUBSCRIPTION_LOAD_ERROR',
  GOOGLE_CALENDAR_LOADING: 'GOOGLE_CALENDAR_LOADING',
  GOOGLE_DISCONNECT_ERROR: 'GOOGLE_DISCONNECT_ERROR',
  GOOGLE_DISCONNECT_LOADING: 'GOOGLE_DISCONNECT_LOADING',
  SUBSCRIPTION_LOAD_SUCCESS: 'SUBSCRIPTION_LOAD_SUCCESS',
  GOOGLE_AUTHENTICATE_FAIL: 'GOOGLE_AUTHENTICATION_FAIL',
  GOOGLE_CALENDAR_LOAD_FAIL: 'GOOGLE_CALENDAR_LOAD_FAIL',
  UPLOAD_PROFILE_PICTURE_ERROR: 'UPLOAD_PROFILE_PICTURE_ERROR',
  GOOGLE_AUTHENTICATE_LOADING: 'GOOGLE_AUTHENTICATION_LOADING',
  GOOGLE_CALENDAR_LOAD_SUCCESS: 'GOOGLE_CALENDAR_LOAD_SUCCESS',
  REMOVE_PROFILE_PICTURE_SUCCESS: 'REMOVE_PROFILE_PICTURE_SUCCESS',
  UPLOAD_PROFILE_PICTURE_SUCCESS: 'UPLOAD_PROFILE_PICTURE_SUCCESS',
  TWO_FACTOR_STATUS_LOADING: 'TWO_FACTOR_STATUS_LOADING',
  TWO_FACTOR_STATUS_SUCCESS: 'TWO_FACTOR_STATUS_SUCCESS',
  TWO_FACTOR_STATUS_ERROR: 'TWO_FACTOR_STATUS_ERROR',
  TWO_FACTOR_VERIFY_PASSWORD_LOADING: 'TWO_FACTOR_VERIFY_PASSWORD_LOADING',
  TWO_FACTOR_VERIFY_PASSWORD_SUCCESS: 'TWO_FACTOR_VERIFY_PASSWORD_SUCCESS',
  TWO_FACTOR_VERIFY_PASSWORD_ERROR: 'TWO_FACTOR_VERIFY_PASSWORD_ERROR',
  TWO_FACTOR_VERIFY_PASSWORD_RESET: 'TWO_FACTOR_VERIFY_PASSWORD_RESET',
  TWO_FACTOR_VERIFY_PASSWORD_CLEAR_FORM: 'TWO_FACTOR_VERIFY_PASSWORD_CLEAR_FORM',
  TWO_FACTOR_VERIFY_PASSWORD_LOCKOUT_RESTORED:
    'TWO_FACTOR_VERIFY_PASSWORD_LOCKOUT_RESTORED',
  TWO_FACTOR_VERIFY_PASSWORD_LOCKOUT_CLEARED:
    'TWO_FACTOR_VERIFY_PASSWORD_LOCKOUT_CLEARED',
  TWO_FACTOR_SETUP_INITIATE_LOADING: 'TWO_FACTOR_SETUP_INITIATE_LOADING',
  TWO_FACTOR_SETUP_INITIATE_SUCCESS: 'TWO_FACTOR_SETUP_INITIATE_SUCCESS',
  TWO_FACTOR_SETUP_INITIATE_ERROR: 'TWO_FACTOR_SETUP_INITIATE_ERROR',
  TWO_FACTOR_SETUP_RESET: 'TWO_FACTOR_SETUP_RESET',
  TWO_FACTOR_VERIFY_SETUP_LOADING: 'TWO_FACTOR_VERIFY_SETUP_LOADING',
  TWO_FACTOR_VERIFY_SETUP_SUCCESS: 'TWO_FACTOR_VERIFY_SETUP_SUCCESS',
  TWO_FACTOR_VERIFY_SETUP_ERROR: 'TWO_FACTOR_VERIFY_SETUP_ERROR',
  TWO_FACTOR_VERIFY_MODAL_PREPARED: 'TWO_FACTOR_VERIFY_MODAL_PREPARED',
  TWO_FACTOR_VERIFY_LOCKOUT_CLEARED: 'TWO_FACTOR_VERIFY_LOCKOUT_CLEARED',
  TWO_FACTOR_RESEND_LOADING: 'TWO_FACTOR_RESEND_LOADING',
  TWO_FACTOR_RESEND_SUCCESS: 'TWO_FACTOR_RESEND_SUCCESS',
  TWO_FACTOR_RESEND_ERROR: 'TWO_FACTOR_RESEND_ERROR',
  TWO_FACTOR_DISABLE_LOADING: 'TWO_FACTOR_DISABLE_LOADING',
  TWO_FACTOR_DISABLE_SUCCESS: 'TWO_FACTOR_DISABLE_SUCCESS',
  TWO_FACTOR_DISABLE_ERROR: 'TWO_FACTOR_DISABLE_ERROR',
  TWO_FACTOR_DISABLE_RESET: 'TWO_FACTOR_DISABLE_RESET',
  SELECT_GOOGLE_CALENDAR,
};

export const devAccessActionTypes = {
  DEV_ACCESS_COMPLETE: 'DEV_ACCESS_COMPLETE',
  DEV_ACCESS_FAIL: 'DEV_ACCESS_FAIL',
  DEV_ACCESS_LOADING: 'DEV_ACCESS_LOADING',
  GET_API_KEY_COMPLETE: 'GET_API_KEY_COMPLETE',
  GET_API_KEY_LOADING: 'GET_API_KEY_LOADING',
  GET_TOKEN_COMPLETE: 'GET_TOKEN_COMPLETE',
  GET_TOKEN_LOADING: 'GET_TOKEN_LOADING',
};

export const ticketActionTypes = {
  ELASTIC_SEARCH: createAction('ELASTIC_SEARCH'),
  PRIORITY_COLORS: createAction('PRIORITY_COLORS'),
  TICKET_COLUMNS: createAction('TICKET_COLUMNS'),
  TICKET_STATS: createAction('TICKET_STATS'),
  TICKET_STATUSES: createAction('TICKET_STATUSES'),
  TICKET_TYPE_COLORS: createAction('TICKET_TYPE_COLORS'),
  TICKETS: createAction('TICKETS'),
  TICKETS_LIST: {
    ...createAction('TICKETS_LIST'),
    ...tableActions('TICKETS_LIST'),
  },
  UPDATE_TICKET_COLUMNS: createAction('UPDATE_TICKET_COLUMNS'),
  UPDATE_TICKET_LIST_TYPE: 'UPDATE_TICKET_LIST_TYPE',
  UPDATE_TICKET_STATUS: createAction('UPDATE_TICKET_STATUS'),
};

export const settingsActionTypes = {
  SETTINGS: createAction('SETTINGS'),
};

export const featureFlagSettingsActionTypes = {
  FEATURE_FLAG_SETTINGS: 'FEATURE_FLAG_SETTINGS',
};

export const equipmentActionTypes = {
  ADD_TAG: 'EQUIPMENT_ADD_FILTER_TAG',
  CHANGE_FILTERS: 'EQUIPMENT_CHANGE_FILTERS',
  CHANGE_QUICK_FILTER: 'CHANGE_QUICK_FILTER',
  INITIAL_LOAD: 'EQUIPMENT_INITIAL_LOAD',
  SEARCH: 'SEARCH',
  ...tableActions('EQUIPMENT'),
};

export const tableActionTypes = {
  SORT_CHANGED: 'SORT_CHANGED',
  PAGE_SIZE_CHANGED: 'PAGE_SIZE_CHANGED',
  PAGE_NUMBER_CHANGED: 'PAGE_NUMBER_CHANGED',
  FILTER_CHANGED: 'FILTER_CHANGED',
};



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js